module.exports = __webpack_public_path__ + "media/images/icon__locked-a99dbc080cad99c1f833dcfb6df599ee.png";